// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"32":"b57b7b4a","178":"b6f5d277","199":"3ac0d8d9","237":"36dece72","587":"f85b0cfc","615":"99d6b4d9","696":"3e76cfcd","766":"9be52dad","925":"946808f2"}[chunkId] + ".js";
};